var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.522 17.522 22 12 22C6.478 22 2 17.522 2 12C2 6.478 6.478 2 12 2C17.522 2 22 6.478 22 12Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 2V12L16.0001 14L11.5786 22C11.7371 22 11.8416 22 12.0001 22C17.5266 22 22.0001 17.5265 22.0001 12C22.0001 6.4735 17.5266 2 12.0001 2Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.522 17.522 22 12 22C6.478 22 2 17.522 2 12C2 6.478 6.478 2 12 2C17.522 2 22 6.478 22 12Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 2V12L16.0001 14L11.5786 22C11.7371 22 11.8416 22 12.0001 22C17.5266 22 22.0001 17.5265 22.0001 12C22.0001 6.4735 17.5266 2 12.0001 2Z",
    fill: "#FFC107"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9201 7.5H12.0001V14L10.5001 13.5L3.58007 6.63H3.57007C5.34007 3.845 8.45507 2 12.0001 2C15.9001 2 19.2751 4.24 20.9201 7.5Z",
    fill: "#F44336"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5791 6.632L8.0006 14.063L10.5001 13.5L3.5791 6.632Z",
    fill: "#DD2C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5786 22L16.0456 13.9705L14.0001 12.5L11.5786 22Z",
    fill: "#558B2F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9325 7.5H11.9999L11.2104 9.79L20.9325 7.5Z",
    fill: "#F9A825"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12C16.5 14.4845 14.4845 16.5 12 16.5C9.5155 16.5 7.5 14.4845 7.5 12C7.5 9.5155 9.5155 7.5 12 7.5C14.4845 7.5 16.5 9.5155 16.5 12Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12C15.5 13.9335 13.9335 15.5 12 15.5C10.0665 15.5 8.5 13.9335 8.5 12C8.5 10.0665 10.0665 8.5 12 8.5C13.9335 8.5 15.5 10.0665 15.5 12Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.43f87d9b741960620e5a2f734831bdbe.svg";
export { ForwardRef as ReactComponent };